import type { LocaleMessageOverrides } from '../types';

// Covers the customer download page and two texts of the print-failed screen.
// Each other key falls back to pt-PT, then to English.
export default {
  errors: {
    // The error overlay gates on `te()`, which ignores the fallback chain, so
    // the one error the download page can raise is repeated here.
    kiosk_not_found:
      'Falha ao carregar o quiosque.\nPor favor, tente novamente.',
    portraits_download_portraits_error:
      "Nenhum retrato encontrado na sua sessão. Se o problema persistir, entre em contato com o suporte pelo e-mail service{'@'}theartisan.ai.",
  },
  OverlayError: {
    buttons: {
      restart: 'Recomeçar',
    },
  },
  CustomerPortraitsDownload: {
    title: 'Digite o código para obter seu retrato',
    buttonSubmit: 'Enviar',
    error:
      'Este código não parece correto. Confira o código de 8 caracteres impresso na sua foto e tente novamente.',
    errors: {
      wrongFormat:
        'Este código não parece correto. Confira o código de 8 caracteres impresso na sua foto e tente novamente.',
      notFound:
        'Desculpe, não encontramos nenhum retrato. Confira o código — ele está impresso na frente do retrato, no canto inferior esquerdo.',
      serverError:
        'Desculpe, não conseguimos carregar seus retratos no momento. Tente novamente mais tarde.',
    },
  },
  CustomerSessionPass: {
    tabs: {
      photos: 'Fotos',
      pass: 'Passe QR',
    },
    eyebrow: 'Seu passe de sessão',
    title: 'Mantenha esta página aberta',
    description:
      'No ponto de compra, escaneie o código quadrado abaixo. Seus retratos estão disponíveis na aba Fotos.',
    descriptionNothingPrinted:
      'No ponto de compra, escaneie o código quadrado abaixo para escolher e imprimir suas fotos.',
    scanLabel: 'Escanear no ponto de compra',
    codeLabel: 'Código da sessão',
    ready: 'Pronto para escanear',
    loading: 'Preparando o código',
    unavailable: 'Código indisponível',
    qrAlt: 'Código QR para o ponto de compra',
    defaultVenue: 'Experiência de retrato TheArtisan.ai',
  },
  CustomerPortraitsDownloadCode: {
    error: 'Ops! Não foi possível carregar este retrato.',
    placeholder: 'Carregando seu retrato…',
    imageAlt: 'Retrato',
    buttonDownload: 'Baixar',
    buttonSendOrShare: 'Enviar ou Compartilhar',
    buttonRetry: 'Tentar Novamente',
    shareTitle: 'Seu retrato de {clientName}',
    shareText: 'Oferecido por TheArtisan.ai',
    states: {
      processing:
        'Seus retratos ainda estão sendo preparados. Tente novamente em instantes.',
      partial:
        'Não foi possível carregar alguns retratos ou detalhes da página. Os downloads disponíveis continuam funcionando.',
    },
    actions: {
      enterAnotherCode: 'Digitar outro código',
      contactSupport: 'Falar com o suporte',
      retryDownload: 'Tentar baixar novamente',
      downloadFailed:
        'O download falhou. Verifique sua conexão e tente novamente.',
      linkCopied: 'Link copiado. Você pode colá-lo em uma mensagem.',
      shareFailed:
        'O compartilhamento não está disponível no momento. Tente novamente.',
    },
  },
  CustomerDigitalExtras: {
    downloadTitle: 'Suas fotos e vídeo',
    downloadIntro: 'Salve suas fotos e o vídeo ou abra seu ingresso QR.',
    photosTitle: 'Suas fotos',
    photosIntro: 'Salve suas fotos ou abra seu passe QR.',
    navigation: 'Seus downloads',
    tabs: {
      photos: 'Fotos',
      extras: 'Vídeo',
      pass: 'Ingresso QR',
    },
    title: 'Seus extras digitais',
    loading: 'Carregando seus extras digitais…',
    loadError:
      'Não foi possível carregar seus arquivos. Verifique sua conexão e tente novamente.',
    included: 'Incluído',
    includedOrder:
      'Seu vídeo está incluído. Guarde o ingresso QR para abri-lo mais tarde.',
    preparingHelp:
      'Salve este link ou guarde seu ingresso QR. Você pode fechar esta página e voltar mais tarde.',
    reference: 'Referência: {reference}',
    retry: 'Tentar novamente',
    empty: 'Nenhum extra digital foi adicionado a esta visita.',
    orderTitle: 'Pedido de vídeo',
    showCashier: 'Mostre este pedido e o ingresso QR no caixa.',
    videoTotal: 'Total do vídeo',
    payAtDesk: 'O pagamento é feito no caixa.',
    preparing: 'Preparando seus arquivos…',
    failed:
      'Não foi possível criar seu vídeo. Mostre a referência abaixo à equipe do local para obter ajuda.',
    ready: 'Pronto para baixar',
    video: 'Foto animada',
    videoDescription:
      'Seu momento favorito em movimento. Para compartilhar nas redes sociais e no grupo da família.',
    download: 'Baixar',
    share: 'Compartilhar arquivo',
    preparingShare: 'Preparando o arquivo…',
    shareFailed:
      'O compartilhamento não está disponível. Use “Baixar” para salvar este arquivo.',
  },
  system: {
    reconnecting: 'Reconectando ao servidor…',
  },
  PrintFailed: {
    titlePartial: '{printed} de {total} fotos impressas',
    captionNotCharged: 'Não cobramos {amount}.',
  },
} satisfies LocaleMessageOverrides;
